
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/help/articles/[...slug]",
      function () {
        return require("private-next-pages/[country]/help/articles/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/help/articles/[...slug]"])
      });
    }
  